import * as React from "react";

function SvgComponent({ color = "#B0B4BA", ...rest }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.879 14.93c.073.072.171.111.274.111h.504a1 1 0 01.708.294l5.818 5.836a1 1 0 010 1.413l-.624.624a1 1 0 01-1.414 0l-5.828-5.823a1 1 0 01-.293-.707v-.507c0-.102-.04-.2-.11-.273a.408.408 0 00-.547-.032 8.826 8.826 0 01-5.49 1.91C3.975 17.776 0 13.796 0 8.888 0 3.979 3.974 0 8.878 0c4.903 0 8.877 3.98 8.877 8.888a8.85 8.85 0 01-1.908 5.497c-.129.164-.119.4.032.546zM2.732 8.889a6.141 6.141 0 006.146 6.153c3.4 0 6.146-2.749 6.146-6.153a6.141 6.141 0 00-6.146-6.154 6.141 6.141 0 00-6.146 6.154z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
